import React, {useCallback, useEffect, useRef, useState} from "react";
import {useOnClickOutside} from "../../Utils/onClickOutside.jsx";
import {useTranslation} from "react-i18next";

import ev_logo from '../../assets/ev_logo_white.png';

import Splash from "../Utils/Splash/index.jsx";
import HamburgerButton from "../HamburgerButton/index.jsx";
import LanguageSwitcher from "../LanguageSwitcher/index.jsx";
import useIsMobile from "../../Utils/isMobileHook.js";

import './style.scss'

const LandingPageNav = () => {

    const [showNav, setShowNav] = useState(false)
    const clickOutsideRef = useRef()
    const { t } = useTranslation();
    const isMobileView = useIsMobile()

    const toggleMobileNav = useCallback(() => {
        setShowNav(prevShowNav => !prevShowNav);
    }, []);

    useOnClickOutside(clickOutsideRef, () => {
        setShowNav(false)
    })


    useEffect(() => {
        if (window.location.hash) {
            const targetElement = document.querySelector(window.location.hash);
            if (targetElement) {
                targetElement.scrollIntoView();
            }
        }
    }, []);

  return <div className={'landing_page_menu'} ref={clickOutsideRef}>
          <div className={'landing_page_menu__logo_container'}>
              <a href={'/#backToTop'}>
              <img src={ev_logo} alt=""/>
              </a>
          </div>
          <div className={'landing_page_menu__nav_container'} >
              <div className={showNav ? 'landing_page_menu__nav_container__buttons_mobile' : 'landing_page_menu__nav_container__buttons'}    >
                  <a href={'/#our_platform'}><b>{t('our_platform')}</b></a>
                  <a href={'/#manage'}><b>{t('manage')}</b></a>
                  <a href={'/#control'}><b>{t('control')}</b></a>
                  <a href={'/#report'}><b>{t('reports')}</b></a>
                  <a href={'/#monitoring'}><b>{t('monitoring')}</b></a>
                  {showNav && <LanguageSwitcher/>}
                  {showNav && <Splash isNavBar={false}/>}
              </div>
          </div>
        {!isMobileView && <Splash/>}
        <HamburgerButton onClick={toggleMobileNav} showNav={showNav}/>
        </div>
}


export default LandingPageNav